




























































































































































import { watch, computed, defineComponent, ref, reactive, PropType } from '@vue/composition-api';
import { ChevronLeftIcon, CloseIcon } from 'tdesign-icons-vue';
import fs from 'fs';
import path from 'path';
import { promisify } from 'util';
import SelectAnySpaceTargetFolder from '@/renderer/components/dialog/SelectAnySpaceTargetFolder/index.vue';
import SyncTypeCard from '@/renderer/views/desktop/FileManagement/FileSync/components/SelectFolder/components/SyncTypeCard.vue';
import CoSyncSettingDrawer from '@/renderer/views/desktop/FileManagement/FileSync/components/SelectFolder/components/CoSyncSettingDrawer.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import tips from '@/renderer/scripts/utils/tips';
import ipc from '@/renderer/scripts/utils/ipc';
import { IpcEvents } from '@/ipc-events';
import { SyncSelectFolder } from '@/renderer/views/desktop/FileManagement/FileSync/composition/SelectFolderHandler';
import { SpaceTag } from '@/renderer/scripts/libs/smh-sdk-class/typings';
import {
  ConflictStrategy,
  CoSyncConfig,
  CoSyncInfo,
  CoSyncSetting,
  CoSyncStrategy,
  CoSyncTaskConfig,
  CoSyncTimingType,
  GetRemotePathWithSpaceAndTeam,
} from '@/workerProcessRenderer/scripts/CoSyncEngine/common/CoSyncConfig';
import useSyncTaskControlHandler from '@/renderer/views/desktop/FileManagement/FileSync/composition/SyncTaskControlHandler';
import { CoSyncReporter } from '@/renderer/views/desktop/FileManagement/FileSync/composition/CoSyncReporter';
import { useSelectFolderConfirm } from '@/renderer/views/desktop/FileManagement/FileSync/composition/SelectFolderConfirm';
import { useCoSyncSettingDrawer } from '@/renderer/views/desktop/FileManagement/FileSync/components/SelectFolder/composition/CoSyncSettingDrawerHandler';
import {
  CmdFromRenderer,
  CmdTypeFromRender,
  UpdateCoSyncSettingParam,
} from '@/renderer/scripts/CoSync/SyncCenter/ServiceMgr/ServiceCommand/CmdFromRenderer';
import { isLocalPathValid } from '@/common/fileUtils';

export default defineComponent({
  components: { SelectAnySpaceTargetFolder, SyncTypeCard, ChevronLeftIcon, CloseIcon, CoSyncSettingDrawer },
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    path: {
      type: String,
      default: '',
    },
    inputConfig: {
      type: Object,
    },
    presetLocalPath: {
      type: String,
    },
    presetRemotePathContext: {
      type: Object as PropType<SyncSelectFolder.RemotePathContext>,
    },
    isBaseLocal: {
      required: true,
      type: Boolean,
    },
  },
  setup(props, context) {
    const { methods: taskControlMethods } = useSyncTaskControlHandler();
    const {
      showSettingSource,
      selectedCoSyncSetting,
      conflictStrategyWording,
      timingTypeWording,
      methods: settingMethods,
    } = useCoSyncSettingDrawer();
    let oldSetting: CoSyncSetting | null = null;

    const innerShow = computed({
      get: () => props.show,
      set: val => {
        context.emit('update:show', val);
      },
    });

    const isCreateBaseLocal = computed(() => props.isBaseLocal);

    const inputUserChoice = computed(() => {
      if (props.inputConfig) {
        return props.inputConfig as CoSyncInfo;
      }
      return null;
    });

    const isEditable = computed(() => inputUserChoice.value === null);
    const isCreateLoading = ref(false);
    const createButtonWording = computed(() => (isCreateLoading.value ? i18n_t('创建中') : i18n_t('确认')));
    const isCancelButtonEnable = computed(() => !isCreateLoading.value);

    const presetLocalPath = computed(() => {
      if (props.presetLocalPath) {
        return props.presetLocalPath as string;
      }
      return null;
    });

    const presetRemoteContext = computed(() => {
      if (props.presetRemotePathContext) {
        return props.presetRemotePathContext as SyncSelectFolder.RemotePathContext;
      }
      return null;
    });

    const dialogHeaderWording = computed(() => {
      if (!isEditable.value) return i18n_t('同步设置');
      if (isCreateBaseLocal.value) return i18n_t('同步本地文件夹');
      return i18n_t('同步云端文件夹');
    });

    const defaultLocalPathUserChoose = '';
    const localPathUserChoose = ref(defaultLocalPathUserChoose);

    const defaultRemotePathUserChoose = '';
    const remotePathUserChoose = ref(defaultRemotePathUserChoose);

    const defaultTeamPath = '';
    const teamPath = ref(defaultTeamPath);

    const remotePathWithSpaceName = computed(() => {
      if (!spaceTag.value) return '';

      const name = GetRemotePathWithSpaceAndTeam(spaceTag.value, teamPath.value, remotePathUserChoose.value);
      return name;
    });

    const defaultSpaceId = '';
    const spaceId = ref(defaultSpaceId);

    const defaultSpaceTag: SpaceTag | null = null;
    const spaceTag = ref<SpaceTag | null>(defaultSpaceTag);

    const defaultTeamId = 0;
    const teamId = ref(defaultTeamId);

    const defaultSpaceOrgId = 0;
    const spaceOrgId = ref(defaultSpaceOrgId);

    const localPathName = computed(() => {
      if (inputUserChoice.value) {
        return path.basename(inputUserChoice.value.config.syncPath.localPath);
      }
      return path.basename(localPathUserChoose.value);
    });
    const remotePathName = computed(() => {
      if (inputUserChoice.value) {
        return path.basename(inputUserChoice.value.config.syncPath.remotePath);
      }
      return path.basename(remotePathUserChoose.value);
    });

    const settingWording = computed(() => [conflictStrategyWording.value, timingTypeWording.value].join(' | '));

    const settingTabs = ref(1);

    const showError = reactive({
      local: false,
      remote: false,
    });

    const showRemoteSelectFolder = ref(false);

    const remoteSyncPathWording = computed(() => {
      if (!isCreateBaseLocal.value) return '';
      if (!remotePathWithSpaceName.value || !localPathName.value) return '';

      const remoteSyncPath = [remotePathWithSpaceName.value, localPathName.value].filter(it => it).join('/');
      return i18n_t('将在您选择的路径下创建 [{slot1}] 的云端同步文件夹', { slot1: path.basename(remoteSyncPath) });
    });

    const localSyncPathWording = computed(() => {
      if (isCreateBaseLocal.value) return '';
      if (!localPathUserChoose.value || !remotePathName.value) return '';
      return i18n_t('将在您选择的路径下创建 [{slot1}] 的本地同步文件夹', {
        slot1: remotePathName.value,
      });
    });

    const syncTypeCradConfig = computed(() => [
      {
        style: '',
        icon: 'RefreshIcon',
        title: i18n_t('双向同步'),
        wording: i18n_t('本地和云端的文件夹完全一致'),
        tooltips: '',
        isSelected: selectedCoSyncSetting.value.strategy === CoSyncStrategy.BOTH,
        onClick: () => settingMethods.updateSyncType(CoSyncStrategy.BOTH),
      },
      {
        style: 'margin-left: 9px',
        icon: 'UploadIcon',
        title: i18n_t('备份到云端'),
        wording: i18n_t('仅将选择的本地文件夹内容同步上传到云端'),
        tooltips: i18n_t('本地文件的删除将不会造成云端内容的删除'),
        isSelected: selectedCoSyncSetting.value.strategy === CoSyncStrategy.LOCAL_TO_CLOUD,
        onClick: () => settingMethods.updateSyncType(CoSyncStrategy.LOCAL_TO_CLOUD),
      },
      // {
      //   style: '',
      //   icon: 'DownloadIcon',
      //   title: '下载同步',
      //   wording: '仅将选择的云端内容同步下载到本地文件夹',
      //   tooltips: '下载同步',
      //   isSelected: coSyncSetting.strategy === CoSyncStrategy.CLOUD_TO_LOCAL,
      //   onClick: () => settingMethods.updateSyncType(CoSyncStrategy.CLOUD_TO_LOCAL),
      // },
    ]);

    const enableEscClose = ref(true);

    const methods = {
      saveRemotePathInfo(
        aSpaceTag: SpaceTag,
        aSpaceId: string,
        completePath: string,
        dirPath: string,
        strSpaceOrgId: string,
        aTeamId: number,
        aTeamPath: string,
      ) {
        if (!isCreateBaseLocal.value && dirPath.length === 0) {
          tips.error(i18n_t('同步云端文件夹时不支持同步根目录'));
          return;
        }

        showError.remote = false;
        if (isCreateBaseLocal.value) {
          showError.local = !localPathUserChoose.value;
        }

        remotePathUserChoose.value = dirPath;
        spaceTag.value = aSpaceTag;
        spaceId.value = aSpaceId;
        teamId.value = aTeamId;
        teamPath.value = aTeamPath;
        showRemoteSelectFolder.value = false;
        const numSpaceOrgId = Number(strSpaceOrgId);
        if (numSpaceOrgId) {
          spaceOrgId.value = numSpaceOrgId;
        }
      },
      async selectLocalPath() {
        const { filePaths } = await ipc.invoke(IpcEvents.INVOKE_OPERATE_MAIN_LISTENER, {
          event: 'selectFolders',
          params: { single: true, noResolveAliases: true },
        });
        if (!filePaths || !filePaths.length) return;

        await this.modifyLocalPath(filePaths[0], false);
      },

      // 处理选中本地文件夹路径的方法
      async modifyLocalPath(filePath: string, fromDrop: boolean) {
        try {
          isLocalPathValid(filePath);
        } catch (error: MsgError) {
          if (error.code === 'NotSupportRootDrive') {
            logger.ui.info('root of disk is not supported');
          } else if (error.code === 'AppFileNotSupported') {
            logger.ui.info('selectLocalPath AppFileNotSupported');
          }
          tips.error(error);
          if (fromDrop) methods.close({ fromUI: false });
          return;
        }

        try {
          const stats = await promisify(fs.lstat)(filePath);
          if (stats.isSymbolicLink()) {
            logger.ui.info('selectLocalPath SymbolicLinkNotSupported');
            tips.error({ code: 'SymbolicLinkNotSupported' } as MsgError);
            if (fromDrop) methods.close({ fromUI: false });
            return;
          }
          if (!stats.isDirectory()) {
            logger.ui.info('selectLocalPath SymbolicLinkOrFileAreNotSupported');
            tips.error({ code: 'SymbolicLinkOrFileAreNotSupported' } as MsgError);
            if (fromDrop) methods.close({ fromUI: false });
            return;
          }
        } catch (error: MsgError) {
          // 获取信息失败的话，不要影响创建，后续执行会有兜底
          logger.ui.warn('fs.lstat error', error);
        }

        showError.remote = false;
        if (!isCreateBaseLocal.value) {
          showError.remote = !remotePathUserChoose.value && !spaceTag.value;
        }

        showError.local = false;
        localPathUserChoose.value = filePath;
      },

      modifyRemotePathContext(remotePathContext: SyncSelectFolder.RemotePathContext) {
        showError.remote = false;
        remotePathUserChoose.value = remotePathContext.remotePath;
        spaceId.value = remotePathContext.spaceId;
        spaceTag.value = remotePathContext.spaceTag;
        spaceOrgId.value = remotePathContext.spaceOrgId;
        teamId.value = remotePathContext.teamId;
        teamPath.value = remotePathContext.teamPath;
      },

      resetForm() {
        isCreateLoading.value = false;

        localPathUserChoose.value = defaultLocalPathUserChoose;
        remotePathUserChoose.value = defaultRemotePathUserChoose;
        spaceId.value = defaultSpaceId;
        spaceTag.value = defaultSpaceTag;
        teamId.value = defaultTeamId;
        teamPath.value = defaultTeamPath;
        spaceOrgId.value = defaultSpaceOrgId;

        oldSetting = null;
        settingMethods.reset();

        showError.local = false;
        showError.remote = false;

        enableEscClose.value = true;
      },

      setupForm(coSyncInfo: CoSyncInfo) {
        const { isCreateBaseLocal, localPath, remotePath } = coSyncInfo.config.syncPath;
        localPathUserChoose.value = isCreateBaseLocal ? localPath : path.dirname(localPath);
        remotePathUserChoose.value = !isCreateBaseLocal ? remotePath : path.dirname(remotePath);
        spaceId.value = coSyncInfo.config.syncPath.spaceId;
        spaceTag.value = coSyncInfo.config.syncPath.spaceTag;
        spaceOrgId.value = coSyncInfo.config.syncPath.spaceOrgId;
        teamId.value = coSyncInfo.config.syncPath.teamId;
        teamPath.value = coSyncInfo.config.syncPath.teamPath;

        oldSetting = structuredClone(coSyncInfo.config.syncSetting);
        settingMethods.setup(coSyncInfo.config.syncSetting);
      },

      close({ fromUI } = { fromUI: true }) {
        innerShow.value = false;
        if (fromUI) {
          CoSyncReporter.getInstance().reportConfigDialogDone('close', isEditable.value);
        }
      },

      cancel() {
        innerShow.value = false;
        CoSyncReporter.getInstance().reportConfigDialogDone('cancel', isEditable.value);
      },

      async submit() {
        if (!isEditable.value) {
          await methods.confirmWhenShowBySetting();
          return;
        }

        await methods.confirmWhenShowByCreate();
      },

      async confirmWhenShowBySetting() {
        const currentLocalSyncId = inputUserChoice.value?.localSyncId;
        if (!currentLocalSyncId) {
          logger.ui.error('currentLocalSyncId should never be null when show by setting');
          return;
        }

        innerShow.value = false;

        // 同步设置有变化
        if (
          oldSetting?.conflictStrategy !== selectedCoSyncSetting.value.conflictStrategy ||
          oldSetting.timingType !== selectedCoSyncSetting.value.timingType
        ) {
          isCreateLoading.value = true;

          await taskControlMethods.applyNoneReturnCommand(currentLocalSyncId, {
            cmdType: CmdTypeFromRender.UPDATE_CO_SYNC_SETTING,
            param: { coSyncSetting: selectedCoSyncSetting.value } as UpdateCoSyncSettingParam,
          } as CmdFromRenderer);

          isCreateLoading.value = false;
          innerShow.value = false;

          CoSyncReporter.getInstance().reportConfigDialogDone('confirm', isEditable.value);
        }
      },

      async confirmWhenShowByCreate() {
        if (!localPathUserChoose.value) {
          showError.local = true;
        }
        if (!remotePathWithSpaceName.value || !spaceTag.value) {
          showError.remote = true;
        }
        if (showError.local || showError.remote) {
          return;
        }

        let nameFromWhichPath = localPathUserChoose.value;
        if (!isCreateBaseLocal.value) nameFromWhichPath = remotePathUserChoose.value;
        const folderName = path.basename(nameFromWhichPath);

        const taskConfig: CoSyncTaskConfig = {
          syncPath: {
            localPath: isCreateBaseLocal.value
              ? localPathUserChoose.value
              : path.join(localPathUserChoose.value, folderName),
            remotePath: !isCreateBaseLocal.value
              ? remotePathUserChoose.value
              : path.posix.join(remotePathUserChoose.value, folderName),
            spaceId: spaceId.value,
            spaceTag: spaceTag.value!,
            spaceOrgId: spaceOrgId.value,
            teamId: teamId.value,
            teamPath: teamPath.value,
            isCreateBaseLocal: isCreateBaseLocal.value,
          },
          syncSetting: selectedCoSyncSetting.value,
        };

        isCreateLoading.value = true;

        const pathComfirmer = useSelectFolderConfirm();
        const confirmRet = await pathComfirmer.confirm(isCreateBaseLocal.value, taskConfig);
        if (!confirmRet) {
          isCreateLoading.value = false;
          return;
        }

        const res = await taskControlMethods.createSyncTask(taskConfig);
        if (res) {
          tips.success(i18n_t('创建成功'));
        }

        isCreateLoading.value = false;

        reporter.report('sync', {
          sync_type: selectedCoSyncSetting.value.strategy,
          sync_time: selectedCoSyncSetting.value.timingType,
          sync_space_type: spaceTag.value,
        });

        innerShow.value = false;

        CoSyncReporter.getInstance().reportConfigDialogDone('confirm', isEditable.value);
      },

      showSyncSetting() {
        showSettingSource.value = inputUserChoice.value
          ? { source: 'setting', coSyncInfo: inputUserChoice.value }
          : { source: 'create' };
      },
    };

    watch(
      () => innerShow.value,
      val => {
        methods.resetForm();
        if (val) {
          if (inputUserChoice.value) {
            const coSyncInfoCopy = structuredClone(inputUserChoice.value);
            methods.setupForm(coSyncInfoCopy);
          } else if (presetLocalPath.value) {
            methods.modifyLocalPath(presetLocalPath.value, true);
          } else if (presetRemoteContext.value) {
            methods.modifyRemotePathContext(presetRemoteContext.value);
          }
        }
      },
    );

    // 处理都响应esc的问题
    watch(
      () => showSettingSource.value,
      val => {
        if (showSettingSource.value.source !== 'none') {
          enableEscClose.value = false;
        } else {
          setTimeout(() => (enableEscClose.value = true), 500);
        }
      },
    );

    return {
      innerShow,
      isCreateBaseLocal,

      isEditable,
      isCreateLoading,
      createButtonWording,
      isCancelButtonEnable,

      dialogHeaderWording,

      localPath: localPathUserChoose,
      spaceTag,
      remotePathWithSpaceName,

      showSelectFolder: showRemoteSelectFolder,
      showError,
      remoteSyncPathWording,
      localSyncPathWording,

      syncTypeCradConfig,
      settingWording,
      showSettingSource,

      settingTabs,

      enableEscClose,

      ...methods,

      selectedCoSyncSetting,
      onSettingUpdate: settingMethods.onSettingUpdate,
    };
  },
});
